import React, { Component } from 'react';
import logo from '../../../images/LogoNameWhite.svg';
import { FooterInfo } from '../css';
import { Link } from 'gatsby';

export default class Footer extends Component {
	render() {
		return (
			<footer>
				<FooterInfo>
					<div>
						<Link to="/">
							<img src={logo} alt="BeeDigital" />
						</Link>
					</div>
					<div>
						<p className="powered">Kontakt:</p>
						<p className="powered">Danebu Kongsgaard</p>
						<p className="powered">Danebuvegen 625, 2910 Aurdal</p>
						<p className="powered">hemsing@danebu.no</p>
					</div>

					<div>
						<p className="rights">copyright &copy; 2021 Hemsing Culture Travel</p>
						<p className="rights">
							Powered by{' '}
							<a href="https://bee-digital.no/" target="_blank" rel="noopener noreferrer">
								BeeDigital AS
							</a>
						</p>

						<p className="rights">
							<a
								className="source"
								href="http://www.onlinewebfonts.com"
								target="_blank"
								rel="noopener noreferrer"
							>
								font by: oNline Web Fonts
							</a>
						</p>
					</div>
				</FooterInfo>
			</footer>
		);
	}
}
